export default __webpack_public_path__ + "static/media/frosty2.2726d382.png";